module.exports = {
  footerText: "ID-Networkers (IDN.ID) © " + new Date().getFullYear(),
};
